// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

import { makeStyles } from "@fluentui/react-components";
import type { ReactNode } from "react";
import { PageLoader } from "../components/layout/PageLoader";

const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
  },
});

export function FullPageFrame({ children }: { children: ReactNode }) {
  const styles = useStyles();
  return <main className={styles.root}>{children}</main>;
}

export function FullPageLoader({ message }: { message?: string }) {
  return (
    <FullPageFrame>
      <PageLoader {...(message !== undefined ? { message } : {})} />
    </FullPageFrame>
  );
}
